/**
 * Created by xuchangxia on 2019/02/14.
 */
import config from '../config/download-app';
import { getSourceH5 } from '../utils/common/soj';
import { getCheckUaObject } from '../utils/common/base';
import soj from './soj';
import {
  isSeoAndSpider, open, autoOpenAppThreeTimes,
} from './open-app';

export default class appdownload {
  constructor() {
    this.client = {};
  }

  /**
     * 添加点击事件
     * @param ele
     * @param binding Object{
     * ***注意*** value 在传入时必须为json字符串
     * example:
     * 1、v-appdownload="{version:'10.3.2',pm:'b391',action:'xxxxx'}" 默认会尝试打开APP新房列表页
     * 2、v-appdownload="{openapp:false,version:'10.3.2',pm:'b391',action:'xxxxx'}" 不尝试打开APP
     * 3、v-appdownload="{pm:34,version:'10.2.1',action:'sadasd',apppage:'loupan',cityid:11,
     *     loupanid:252896,refer:'xxxxxx'}"  尝试打开openapp组件所支持的楼盘单页
     * 4、v-appdownload="{appname:'weiliaoke',action:'xxxxx'}" 下载微聊客APP
     *  value:{
     *      page: 页面名，发码用,
     *      apppage: 要打开的app页面的名字（优先级高于openurl）loupan，housetype，zixun，home
     *               1.loupan时需要再value里另外传递extra_loupan_id
     *               2.housetype时需要再value里另外传递house_type_id和extra_loupan_id
     *               3.home时无需要额外
     *      openurl: 指定打开的url
     *      openapp: 是否打开app，默认不传也是打开,
     *      refer:  用于统计打开app的来源
     *      pm:安装渠道,包号，标记页面点击的具体地方
     *      version:安卓版本号，下载指定的安卓版本
     *      action:  soj自定义action(发码的名称)
     *      city_id:  城市id，比如上海对应的cityId="11"
     *      extra_loupan_id: 具体要打开的楼盘单页对应的楼盘id，appPage = housetype/loupan，需要传此参数
     *      house_type_id: 户型id，appPage = housetype时;需要再value里另外传递houseTypeId
     *  }
     * }
     */
  clickDownload(ele, binding) {
    let { value } = binding;
    if (isSeoAndSpider()) {
      return false;
    }
    try {
      if ((typeof value).toLowerCase() === 'string') {
        value = JSON.parse(value);
      }
    } catch (e) {
      // do nothing
    }
    const {
      appPath, page, refer, isAutoOpenAppThreeTimes,
    } = value;
    if (isAutoOpenAppThreeTimes && autoOpenAppThreeTimes(page)) {
      this.awakeUrl(appPath, page, refer);
    }
    ele.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.checkDownload(ele, value);
    }, false);
    return true;
  }

  awakeUrl(appPath, page, refer) {
    const uaObj = getCheckUaObject();
    if (uaObj.openharmony) {
      // 鸿蒙统一跳首页，暂不支持跳自定义页面
      this.openAppSrc = 'openanjuke://app.anjuke.com/home/';
    } else if (appPath && appPath.length > 0) {
      this.openAppSrc = `openanjuke://jump/${appPath}`;
    } else {
      this.openAppSrc = 'openanjuke://jump/app/main_tab_page';
    }
    let sojRefer = '';
    if (page && page.length > 0) {
      sojRefer = page + (refer ? (`_${refer}`) : '');
    }
    const joiner = this.openAppSrc.indexOf('?') > 0 ? '&' : '?';
    window.location = `${this.openAppSrc}${joiner}refer=${sojRefer}`;
  }

  checkDownload(ele, value) {
    // if target is a link ,no download action
    let href = ele.getAttribute('href');
    if (href) {
      href = String(href).trim().toLowerCase();
      if (href.indexOf('javascript') < 0) {
        return false;
      }
    }
    this.download(value);
    return true;
  }

  /**
     * 执行下载
     * @param ele
     * @param binding
     */
  download(value) {
    const appInfo = config.site.appInfo || {};
    // ajk app
    const action = value.action || appInfo.action;
    const pm = value.pm || appInfo.apm;
    const version = value.version || appInfo.version;
    const wxUrl = appInfo.weixinUrl;
    const androidUrl = `${appInfo.androidUrl}get_version=${version}&pm=${pm}&${pm}.apk`;
    const harmonyUrl = appInfo.harmonyLink;
    const appname = 'anjuke';
    const uaObj = getCheckUaObject();
    const iosUrl = appInfo.iosHighUrl;
    const pageName = value.page || '';
    const additionalParam = value.additionalParam || {};
    const isSendSojComponent = value.isSendSojComponent || false;
    // client 发码用
    this.client = {
      source: value.sourceSoj,
      system: value.systemSoj,
      version: value.versionSoj,
    };
    // 业务发码，点击码，点一次发一次
    if (value.isSendSojBusiness) {
      const cpInBuiness = Object.assign({}, {
        appname,
        pm,
        pageName,
      }, additionalParam);
      this.sendClickSoj(
        action, cpInBuiness,
      );
    }

    if (uaObj.weixin) {
      // 微信
      window.location.href = wxUrl;
    } else if (uaObj.ioshigh) {
      // 安居客ios版已经只支持ios9以及以上了 20190514
      if ((value.openapp && value.openapp === 'true') || value.openapp === undefined) {
        // 打开
        open(value);
      } else {
        // 纯下载
        window.location.href = appInfo.iosUrl;
      }
    } else if ((value.openapp && value.openapp === 'true') || value.openapp === undefined) {
      open(value);
      this.checkHasApp(Date.now(), wxUrl, androidUrl, harmonyUrl, iosUrl, action, appname, pm, pageName, isSendSojComponent);
    } else {
      // 纯下载
      this.checkHasApp(Date.now(), wxUrl, androidUrl, harmonyUrl, iosUrl, action, appname, pm, pageName, isSendSojComponent, true);
    }

    return true;
  }

  /**
     * 是否已经安装app
     * @param originTime
     * @param wxUrl
     * @param androidUrl
     * @param harmonyUrl
     * @param iosUrl
     * @param track
     * @param appname
     * @param pm
     */
  checkHasApp(originTime, wxUrl, androidUrl, harmonyUrl, iosUrl, track, appname, pm, pageName, isSendSojComponent, onlyDownload = false) {
    let hasApp = false;
    let displayTime = originTime;
    let firstClick = true;
    let action = 'appdownload_in';
    if (track) {
      action = `${track}_${action}`;
    }
    const trackObj = {
      action,
      cp: {
        appname,
        pm,
        pageName,
      },
    };
    if (onlyDownload) {
      // 纯下载
      this.downloadApp(trackObj, isSendSojComponent, {
        wxUrl,
        androidUrl,
        harmonyUrl,
        iosUrl,
      });
    } else {
      setTimeout(() => {
        const time = setInterval(() => {
          const timenow = Date.now();
          if (firstClick) {
            firstClick = false;
            displayTime = timenow;
            return;
          }
          if (timenow - displayTime > 200) {
            hasApp = true;
            clearInterval(time);
            return;
          }
          hasApp = false;
          displayTime = timenow;

          if (displayTime > originTime + 1500) {
            clearInterval(time);
            if (Date.now() - originTime > 3000) {
              hasApp = true;
            }
            if (!hasApp) {
              this.downloadApp(trackObj, isSendSojComponent, {
                wxUrl,
                androidUrl,
                harmonyUrl,
                iosUrl,
              });
            }
          }
        }, 100);
      }, 200);
    }
  }

  downloadApp(trackobj = {}, isSendSojComponent, url = {}) {
    const uaObj = getCheckUaObject();
    const uaUtil = uaObj || {};
    const trackObj = trackobj;
    if (uaUtil.weixin) {
      trackObj.action += '_weixin';
      if (isSendSojComponent) this.sendClickSoj(trackObj.action, trackObj.cp);
      window.location.href = url.wxUrl;
    } else if (uaUtil.android) {
      trackObj.action += '_android';
      if (isSendSojComponent) this.sendClickSoj(trackObj.action, trackObj.cp);
      window.location.href = url.androidUrl;
    } else if (uaUtil.openharmony) {
      trackObj.action += '_openharmony';
      if (isSendSojComponent) this.sendClickSoj(trackObj.action, trackObj.cp);
      window.location.href = url.harmonyUrl;
    } else {
      trackObj.action += '_ios';
      if (isSendSojComponent) this.sendClickSoj(trackObj.action, trackObj.cp);
      window.location.href = url.iosUrl;
    }
  }

  sendClickSoj(action, cus_cp = {}) {
    const formatClient = getSourceH5(this.client);
    const cp = Object.assign({}, formatClient, cus_cp);
    soj.trackEvent(action, cp, 2, cus_cp.pageName);
  }
}
